<template>
  <div ref="drawerBox">
    <div style="margin-bottom: 10px;">
      <a-button type="primary" style="margin-right: 12px" @click="showAdd">
        新增配方
      </a-button>
      <a-button gohst style="margin-right: 12px" @click="deleteList" :disabled='selectedRowKeys.length === 0'>
        移出配方
      </a-button>
      <div style="float: right;padding-right:20px">
        <a-dropdown>
          <a-button size="small" ghost type="primary">
            同步数据
            <a-icon type="down"/>
          </a-button>
          <a-menu slot="overlay" @click="synchronizeData">
            <a-menu-item :key="index + 1" v-for="(item, index) in [
              '同步销售月计划',
              '同步工单产量',
            ]">{{ item }}</a-menu-item>
          </a-menu>
        </a-dropdown>
        <!-- <a-tooltip>
          <template slot="title">
            同步工单产量
          </template>
          <a-icon type="swap" @click="synchronizeData"
            :style="{cursor: list.length === 0 ? 'no-drop' : 'pointer',color: list.length === 0 ? 'gray' : '#1890ff'}" />
        </a-tooltip> -->
      </div>
    </div>
    <a-table ref="listRef" :scroll="{y}" class="textLeft1" :columns="columns" :data-source="list"
      :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" rowKey="id" :pagination="false">
      <template slot="formulaForecast" slot-scope="text, record">
        <div v-if="record.isTotal" style="text-align: center">{{text ? Number(text).toFixed(3) : ''}}</div>
        <cell-editor v-else :len="3" :item="record" key="formulaForecast" name="formulaForecast"
          @blur="target => itemUpdate(target,record.id)" :text="text" :background="true" />
      </template>
      <!-- <div slot="formulaForecast" slot-scope="text,record" style="position: relative;height: 25px;">
          <div v-if="record.isTotal">{{text}}</div>
          <div v-else style="height: 25px;">
            <cell-editor :len="3" :item="record" key="formulaForecast" name="formulaForecast" @blur="target => itemUpdate(target,record.id)" :text="text" :actions="() => saveList(record,'row')" :background="true" /> -->
      <!-- <div v-if="!record.edit">
              <a-spin :spinning="loading && recordObj.formulaCode === record.formulaCode" size="small" class="spinning-block">
                <span>{{text || text === 0?text.toFixed(3):text}}</span>
              </a-spin>
            </div>
            <div v-else>
              <a-input-number  style="width: 100%" ref="getFocus" v-model="record.formulaForecast" :step="0.001"  :precision="3" :max="9999999999" :min="0" @blur="saveList(record,'row')" @pressEnter="saveList(record,'row')"/>
            </div> -->
      <!-- </div>
        </div> -->
    </a-table>

    <!-- 新增列表 -->
    <a-modal title="新增配方" :visible="addVisible" :confirm-loading="false" @ok="addSubmit" @cancel="showAddFunc"
      cancelText='取消' okText='确定' :maskClosable='false' width='800px' destroyOnClose>
      <Formula ref='formula' :drwaerObj="drwaerObj" />
    </a-modal>
  </div>
</template>
<script>
import Formula from './Formula.vue'
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import CellEditor from './CellEditor.vue'
export default {
  components: { Formula, CellEditor },
  props:{
    drwaerObj: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  data(){
    return{
      locale,
      loading: false,
      addVisible:false,
      y: 500,
      recordObj:{},
      columns:[
        {title: '配方类型',dataIndex: 'formulaTypeStr'},
        {title: '配方名称',dataIndex: 'formulaName'},
        {title: '配方代码',dataIndex: 'formulaCode'},
        {title: '配方预计产量',dataIndex: 'formulaForecast',scopedSlots: { customRender: 'formulaForecast' }},
        {title: '重量单位',dataIndex: 'weightUnit'},
      ],
      selectedRowKeys: [],
      list:[],
    }
  },
  mounted(){
    this.getList()
    this.y = this.$refs.drawerBox.offsetHeight - 100
  },
  methods:{
    itemUpdate(item,id){
      const newData = [...this.list]
      const targets = newData.filter(item => id === item.id)[0]
      if (targets) {
        this.list = newData
        Object.assign(targets, item)
        this.list = newData
        this.saveList(item)
      }
    },
    saveList(record){
      this.loading = true
      record.edit = false
      this.$post(`/nhf-app/productiondetail/update`,record).then(res => {
        let {success} = res;
        if(success){
          // this.$message.success('修改成功')
          record.edit = false
          this.recordObj = {}
          this.loading = false
          this.setList()
        }
        // else{
        //   this.$message.error('修改失败')
        // }
      }).catch(() => {
        record.edit = false
        this.recordObj = {}
        this.loading = false
      })
    },
    renderColumns(columns) {
      return columns.map(item => {
        if(item.dataIndex === 'formulaForecast'){
          return {
            ...item,
            customCell:(record) => {
              return {
                on:{
                  click: () => {
                    if(this.recordObj.formulaCode) return
                    this.editRow(record,'edit')
                  },
                },
                style: {
                  background: record.isTotal ? 'transparent' : '#e6f7ff'
                }
              }
            }
          }
        }else{
          return item
        }
      })
    },
    getTotal(data=[]){
      let num = 0
      data && data.forEach(el => {
        if(!el.isTotal) num += Number(el.formulaForecast || 0)
      })
      return num
    },
    setList(){
      let num = this.getTotal(this.list)
      let len = this.list.length > 0 ? this.list.length - 1 : 0
      this.list[len].formulaForecast = num
    },
    synchronizeData({ key }) {
      let url = '/nhf-app/productiondetail/syncProductionForecast';
      const params = { forecastId: this.drwaerObj.id };
      const factoryDetail = JSON.parse(window.localStorage.getItem("factoryDetail") || "{}");
        if (factoryDetail.ebsEntityCode) {
          params.ebsEntityCode = factoryDetail.ebsEntityCode;
        }
      if (key == 1) {
        url = '/nhf-app/productiondetail/syncEbsMonth';
      }

      this.$http.post(url, params).then(res => {
        let { success, msg } = res || {};
        this.$message[success ? 'success' : 'warning'](msg);
        if (success) this.getList();
      })
    },
    getList(){
      let params = {
        forecastId: this.drwaerObj.id
      }
      this.$http.get('/nhf-app/productiondetail/list',{params}).then(res => {
        let {success,data} = res;
        if(success){
          data && data.map(el => {
            el.edit = false
            return el
          })
          if(data.length > 0){
            let num = this.getTotal(data)
            let weightUnit = data[0].weightUnit
            data.push({
              formulaTypeStr: '合计',
              isTotal: true,
              formulaForecast: num,
              weightUnit
            })
          }
          this.list = data
          // let list = []
          // let num = data.length - 1
          // for(let i=0;i<100;i++){
          //   let val = parseInt(i/num)
          //   data[i-num*val].id = i
          //   list.push(data[i-num*val])
          // }
          // this.list = list
        }
      })
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    showAdd(){
      this.addVisible = true
    },
    addSubmit(){
      let {selectedRowKeys: formulaId} = this.$refs.formula
      if(!formulaId || formulaId.length === 0) {
        this.$message.error('请选择新增配方')
        return
      }
      let data = {
        forecastId:this.drwaerObj.id,
        formulaId
      }
      this.$http.post('/nhf-app/productiondetail/addByMonthPlan',data).then(res => {
        let {success,msg} = res;
        if(success){
          this.$message.success('新增成功')
          this.showAddFunc()
        }else{
          msg && this.$message.error(msg)
        }
        this.getList()
      })
    },
    showAddFunc(){
      this.addVisible = false
    },
    editRow(record,type){
      if(type === 'edit'){
        record.edit = true
        this.recordObj = JSON.parse(JSON.stringify(record))
        setTimeout(() => {
          this.$refs.getFocus.focus()
        }, 0);
      }
    },
    deleteList(){
      let ids = this.selectedRowKeys.join(',')
      this.$confirm({
        title: '移出配方',
        okText: '确定',
        cancelText: '取消',
        content: () => <div><span style="color:red;">配方移出后，该配方中原料将不再评估</span>你还要继续吗？</div>,
        onOk:() => {
          this.$http.post(`/nhf-app/productiondetail/remove?ids=${ids}`).then(res => {
            let {success} = res;
            if(success){
              this.$message.success('删除成功')
              this.selectedRowKeys = []
            }else{
              this.$message.error('删除失败')
            }
            this.getList()
          })
        }
      });
    }
  }
}
</script>
<style lang="scss">
.textLeft1{
  .ant-table-thead > tr > th, .ant-table-tbody > tr > td{
    position: relative;
  }
}
</style>